module.exports = {"330113001":"临平街道","330113002":"南苑街道","330113003":"东湖街道","330113004":"星桥街道","330113005":"乔司街道","330113006":"运河街道","330113007":"崇贤街道","330113100":"塘栖镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330113.json
// module id = 1051
// module chunks = 0